import React, { useContext, useState, useEffect } from 'react';
import CurrencyContext from '../../contexts/CurrencyContext';
import { getCurrency } from '../../shared/product-page-placement/currency';
import { logError } from '../../shared/utils/logging';
import { formatMoney } from '../../dissolve/utils';

const MoneyFormat = ({
  amount,
  short = false,
}: {
  amount: number;
  short?: boolean;
}) => {
  const { currency, convertPrice } = useContext(CurrencyContext);
  const [price, setPrice] = useState<string | null>();

  useEffect(() => {
    async function customFormattingFunction() {
      let moneyFormat = 'CANDYRACK_CUSTOM_FORMAT_MONEY';
      try {
        const { currency } = getCurrency();
        if (window.CANDYRACK_CUSTOM_FORMAT_MONEY) {
          moneyFormat = 'CANDYRACK_CUSTOM_FORMAT_MONEY';
          setPrice(
            await window.CANDYRACK_CUSTOM_FORMAT_MONEY(amount, currency),
          );
        } else if (window.CANDYCART_CUSTOM_FORMAT_MONEY) {
          moneyFormat = 'CANDYCART_CUSTOM_FORMAT_MONEY';
          setPrice(
            await window.CANDYCART_CUSTOM_FORMAT_MONEY(amount, currency),
          );
        }
      } catch (error) {
        logError(`${moneyFormat} failed`, error);
        setPrice(null);
      }
    }
    customFormattingFunction();
  }, [amount, currency]);

  if (price) {
    return <span dangerouslySetInnerHTML={{ __html: price }} />;
  }

  return (
    <>
      {formatMoney(
        convertPrice(amount),
        currency || getCurrency().currency,
        short,
      )}
    </>
  );
};

export default MoneyFormat;
